export default __webpack_public_path__ + "static/images/lisa_02.png";